export default "__VITE_ASSET__7Hjmokqz__"